import type { StoryStatus } from "@actale/contracts";

const STATUS_LABELS: Record<StoryStatus, string> = {
  DRAFT: "草稿",
  READY: "待发布",
  PUBLISHED: "已发布",
  ARCHIVED: "已归档",
};

export function storyStatusLabel(status: StoryStatus): string {
  return STATUS_LABELS[status];
}

export function formatUpdatedAt(value: string): string {
  return new Intl.DateTimeFormat("zh-CN", {
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
}

